import PagedFilterAndSortedRequest from "./../store/entities/page-request";
import AppConsts from "@/lib/appconst";
import AbpBase from "@/lib/abpbase";
import { Component} from 'vue-property-decorator';
@Component
export default class PagedListingComponentBase
    extends AbpBase {
    /**
     * 分页大小
     */
    public pageSize = AppConsts.defaultPagesize;

  /**
   * 当前页
   */ public pageNumber = 1;
    /**
     * 总页数
     */
    public totalPages = 1;
    /**
     * 总记录数
     */
    public totalItems: number = 1;
    /**
     * 是否加载中
     */
    public isTableLoading = true;

    /**
     * 是否全部选中
     */
    public allChecked: boolean = false;

    /**
     * 全选框是否禁用
     */
    public allCheckboxDisabled = false;
    /**
     * 选择框非全选状态，控制全选框的样式：☒
     */
    public checkboxIndeterminate = false;

    /**
     * 已选中数据项列表
     */
    public selectedDataItems: any[] = [];
    /**
     * 排序
     */
    public sorting: string = undefined;
    public pagesizeopts: number[] = [10, 20, 30,50,100,200];
    /**
     * 模糊搜索的文本
     */
    filterText = '';

    /**
     * 数据表的数据源
     */
    dataList: any[] = [];

    OnInit(): void {
        this.refresh();
    }

    /**
     * 刷新表格数据
     * @param args
     */
    refresh(): void {
        this.pageNumber=1;
        this.restCheckStatus(this.dataList);
        this.getDataPage(this.pageNumber);
    }

    /**
     * 刷新表格数据并跳转到第一页（`pageNumber = 1`）
     */
    refreshGoFirstPage(): void {
        this.pageNumber = 1;
        this.restCheckStatus(this.dataList);
        this.getDataPage(this.pageNumber);
    }


    public getDataPage(page: number): void {
        // if (page <= 0) {
        //   this.pageNumber = 1;
        //   this.refresh();
        //   return;
        // }
       
        const req = new PagedFilterAndSortedRequest();
        req.maxResultCount = this.pageSize;
        req.skipCount = (page - 1) * this.pageSize;
        req.sorting = this.sorting;
        this.isTableLoading = false;
        this.fetchDataList(req, page, () => {
            this.isTableLoading = true;
            // 更新全选框禁用状态
            this.refreshAllCheckBoxDisabled();
            this.refreshCurrentPageCheck();
        });
    }
    //刷新当前页的选中项 这个方法在 换页的时候调用
    refreshCurrentPageCheck(): void {
        this.dataList.filter(x => {
            if (this.selectedDataItems.findIndex(p => (<any>p).id == (<any>x).id) != -1) {
                (<any>x)._checked = true;
            }
        })
        this.refreshCheckStatus(this.dataList);
    }
    /**
     * 刷新全选框是否禁用
     */
    refreshAllCheckBoxDisabled(): void {
        this.allCheckboxDisabled = this.dataList.length <= 0;
    }
    public pageNumberChange(e): void {
        
        if (this.pageNumber > 0) {
            this.pageNumber = e;
            //this.refresh();
            this.refreshNew();
        }
    }
    

    pagesizeChange(pagesize: number) {
        this.pageSize = pagesize;
        this.refresh();
    }
   
    refreshNew() {
        this.allChecked = false;
        this.checkboxIndeterminate = false;
        this.getDataPage(this.pageNumber);
    }


    /**
     * 选中全部记录
     * @param value 是否选中
     */
    checkAll(value: boolean): void {
        this.dataList.forEach(data => ((<any>data)._checked = this.allChecked));
        this.refreshCheckStatus(this.dataList);
    }
   
    /**
     * 刷新选中状态
     */
    refreshCheckStatus(entityList: any[]): void {
        
        const _this = this;
        this.selectedDataItems = entityList;
        // 是否全部选中
        const allChecked = this.selectedDataItems.length > 0 && this.selectedDataItems.length == entityList.length;
        // 是否全部未选中
        const allUnChecked = this.selectedDataItems.length == 0;
        // 是否全选
        this.allChecked = allChecked;

    }
    getone()
    {
    }
    /**
     * 重置选中状态
     */
    restCheckStatus(entityList: any[]): void {
        this.allChecked = false;
        this.checkboxIndeterminate = false;
        // 已选中数据
        this.selectedDataItems = [];
        // 设置数据为未选中状态
        entityList.forEach(value => (value._checked = false));
    }
    /**
     * 计算分页
     * @param result 分页结果Dto
     * @param pageNumber 当前页码
     */
    public showPaging(result: any): void {
        this.totalItems = result.totalCount;
        this.totalPages = Math.ceil(result.totalCount / this.pageSize);
    }

    /**
     * 数据表格排序
     * @param sort 排序信息
     */
    gridSort(a) {
        if(a.order=="normal"){
            this.sorting=undefined;
        }else{
            this.sorting = a.key +' '+a.order;
        }
       
        this.refresh();
    }



    /**
     * 获取数据抽象接口，必须实现
     * @param request 请求必需参数 skipCount: number; maxResultCount: number;
     * @param pageNumber 当前页码
     * @param finishedCallback 完成后回调函数
     */
    
    public  fetchDataList(
        req: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function,
    ): void{
          
    };
}
